import { BodyDefaultTypography } from '@npco/zeller-design-system'
import styled from 'styled-components'

export const StyledTextInputPrefix = styled.span`
  color: ${({ theme }) => theme.colors.GREY_550};
  ${BodyDefaultTypography};
  transition: color 0.3s ease-out;
`
